var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-modal',{attrs:{"name":"move-directory-modal","title":_vm.title,"width":"30%"},on:{"before-open":_vm.beforeOpen,"before-close":_vm.beforeClose,"on-ok":_vm.onOk}},[_c('app-form',{ref:"form",attrs:{"schema":_vm.schema,"data":_vm.formModel},on:{"on-submit":_vm.onSubmit}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16a5680a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/portal-components/directory-list/move-directory-modal.vue
// module id = HSj1
// module chunks = 23